// Guards against SecurityError thrown when sessionStorage is blocked by the browser
// (strict privacy mode, sandboxed webviews, certain Safari contexts, etc.).
const safeSessionStorage = {
  getItem(key) {
    try { return sessionStorage.getItem(key); } catch { return null; }
  },
  setItem(key, value) {
    try { sessionStorage.setItem(key, value); } catch { /* deliberately silent */ }
  },
  removeItem(key) {
    try { sessionStorage.removeItem(key); } catch { /* deliberately silent */ }
  }
};

export default safeSessionStorage;